<template>
  <div id="contenedor-contrato-fianzas-main">
    <tool-bar
      v-if="!$apollo.loading"
      class="my-3"
      v-on:nuevaFianza="registrarNuevaFianza"
    >
    </tool-bar>
    <!-- Loader -->
    <v-skeleton-loader
      v-if="$apollo.loading"
      type="table-heading, table-thead, table-tbody"
    >
    </v-skeleton-loader>
    <listado
      v-if="!$apollo.loading"
      :listadoFianzas="getContratoFianzas">
    </listado>
    <!-- Ventana Registrar Nueva Fianza -->
    <v-dialog
      v-model="mostrarRegistrarNuevaFianza"
      width="600"
      persistent>
      <nueva-fianza
        v-if="contrato && mostrarRegistrarNuevaFianza"
        :contrato="contrato"
        v-on:cerrar="cerrarVentana"
      >
      </nueva-fianza>
    </v-dialog>
    <!-- Ventana Editar Fianza -->
    <v-dialog
      v-if="estaFianza"
      v-model="mostrarEditarFianza"
      width="500">
        <editar-fianza
          :contratoFianzaEditar="estaFianza"
          v-on:cerrar="cerrarVentana"
        />
    </v-dialog>
    <!-- Ventana Eliminar Fianza -->
    <v-dialog
      v-if="estaFianza"
      v-model="mostrarEliminarFianza"
      :width="!$vuetify.breakpoint.mobile ? '450' : '90%'">
        <eliminar-fianza
          :contratoFianzaEliminar="estaFianza"
          v-on:cerrar="cerrarVentana"
        />
    </v-dialog>
  </div>
</template>

<script>
import CONTRATO from '@/graphql/querys/administracion/contratos/contrato.gql';
import CONTRATO_FIANZAS from '@/graphql/querys/administracion/contratos/fianzas/contratoFianzas.gql';
import ToolBar from './ToolBar.vue';
import NuevaFianza from '@/components/administracion/contratos/contrato/fianza/Nueva.vue';
import EditarFianza from '@/components/administracion/contratos/contrato/fianza/Editar.vue';
import EliminarFianza from '@/components/administracion/contratos/contrato/fianza/Eliminar.vue';
import Listado from './listado/Main.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'ContratoFianzasMain',
  components: {
    ToolBar,
    Listado,
    NuevaFianza,
    EditarFianza,
    EliminarFianza,
  },
  data() {
    return {
      mostrarRegistrarNuevaFianza: false,
      mostrarEditarFianza: false,
      mostrarEliminarFianza: false,
      estaFianza: null,
    };
  },
  methods: {
    registrarNuevaFianza() {
      this.mostrarRegistrarNuevaFianza = true;
    },
    cerrarVentana() {
      this.mostrarRegistrarNuevaFianza = false;
      this.mostrarEditarFianza = false;
      this.mostrarEliminarFianza = false;
      this.estaFianza = null;
    },
  },
  apollo: {
    contrato: {
      query: CONTRATO,
      variables() {
        return {
          id: this.$route.params.idContrato,
        };
      },
    },
    contratoFianzas: {
      query: CONTRATO_FIANZAS,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
  },
  computed: {
    getContratoFianzas() {
      if (!this.contratoFianzas) return [];
      return this.contratoFianzas
        .slice()
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    },
  },
  mounted() {
    eventBus.$on('editar-fianza-contrato', (fianzaContrato) => {
      this.estaFianza = fianzaContrato;
      this.mostrarEditarFianza = true;
    });
    eventBus.$on('eliminar-fianza-contrato', (fianzaContrato) => {
      this.estaFianza = fianzaContrato;
      this.mostrarEliminarFianza = true;
    });
  },
};
</script>

<style lang="scss">
</style>
